import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";

interface BadgeProps {
  label: string;
  isDefault: boolean;
}

export const Badge = ({ label, isDefault }: BadgeProps) => (
  <div
    className={classNames(
      "rounded-full border border-[#4614C9] px-2.5 py-1 text-sm",
      isDefault ? "bg-[#EFEAFB] text-[#4614C9]" : "bg-white text-[#4614C9]",
    )}
  >
    <Typography.LabelXs color="text-primary">{label}</Typography.LabelXs>
  </div>
);
